import React from 'react';
import ReactToPrint from "react-to-print";

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="react-print-none">
                                                <ol className="brownbullet-list listcontentSpacing" start="12">

                                                    <li><p><span className="subtiltereg">Become ‘realistically optimistic’ when considering setbacks or disappointments. </span> Just
                                                        as
                                                        you should not give up too soon, neither should you
                                                        obstinately persist when a situation is
                                                        deemed ‘hopeless’. Apply a sound cost/benefit analysis when
                                                        deciding if and what action
                                                        you will take to overcome the presenting obstacles.</p></li>

                                                </ol>
                                                <div className="circle_title referencepad"><img
                                                    src={require('@images/Browndot.png')}
                                                    alt=""/>ENERGY FIELD EXERCISE
                                                </div>
                                                <p>In order to complete the following exercise you should:</p>
                                                <div
                                                    className="lightgreencontentbg keyquestionpad uiheading lightbgui1">
                                                    <ul className="greenbullet-list uiheading">
                                                        <li><p>Have read through this tool and understood the key
                                                            messages about driving/
                                                            restraining forces, equilibrium and flow.</p></li>
                                                        <li><p>Have looked at the example model of an energy
                                                            field.</p></li>
                                                        <li className=""><p>Think laterally and be creative!</p>
                                                        </li>
                                                    </ul>

                                                </div>
                                                <div className="paraspace"><p>Your task:</p></div>
                                                <ol className="brownbullet-list listcontentSpacing">
                                                    <li><p>Refer back to the Energy field model to consider your
                                                        ‘flow factors’. Use the table on the
                                                        following page to note down your flow factors.</p></li>
                                                    <li><p>Think about the following questions in order to identify
                                                        the driving and restraining forces in
                                                        your own working environment:</p></li>

                                                </ol>
                                                <p></p>
                                            </div>

                                            <ReactToPrint
                                                trigger={() => <div className={'d-flex justify-content-end'}>
                                                    <div onClick={this.downloadPdf} className="button-print task">Print</div>
                                                </div>}
                                                content={ () => {
                                                    let html = document.body.getElementsByClassName('ilead-tools-pages-content')[0].cloneNode(true);

                                                    let div1 = document.createElement('div');
                                                    div1.className = 'ilead-tools-pages';
                                                    div1.appendChild(html);

                                                    let div2 = document.createElement('div');
                                                    div2.className = 'ilead-tools-body react-print';
                                                    div2.appendChild(div1);

                                                    return div2.cloneNode(true);
                                                }}
                                            />

                                            <br/>
                                            <table className="ilead_v_sport people_active" border="0"
                                                   cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve green_curve1" align="left"
                                                        valign="top" width="100%">Identify your Driving and
                                                        Restraining Forces
                                                    </th>
                                                </tr>


                                                <tr>
                                                    <td className=" darkgreen " align="left" valign="top"
                                                        width="50%"><p>1. Which conditions or factors need
                                                        to be present for you to function optimally?</p>

                                                        <textarea className="TaskTextArea1"
                                                            name="1"
                                                            value={this.props.pageData?.IdentifyYourDrivingAndRestrainingForces?.[1]}
                                                            onChange={this.props.handleChangePageData('IdentifyYourDrivingAndRestrainingForces')}/>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className="lightgreen " align="left" valign="top"
                                                        width="50%"><p>2. When (at which times) do you
                                                        operate at your best?</p>

                                                        <textarea className="TaskTextArea1"
                                                                  name="2"
                                                                  value={this.props.pageData?.IdentifyYourDrivingAndRestrainingForces?.[2]}
                                                                  onChange={this.props.handleChangePageData('IdentifyYourDrivingAndRestrainingForces')}/>
                                                    </td>
                                                </tr>


                                                <tr>
                                                    <td className=" darkgreen " align="left" valign="top"
                                                        width="50%"><p>3. Alternatively, when don’t you
                                                        operate at your best?</p>

                                                        <textarea className="TaskTextArea1"
                                                                  name="3"
                                                                  value={this.props.pageData?.IdentifyYourDrivingAndRestrainingForces?.[3]}
                                                                  onChange={this.props.handleChangePageData('IdentifyYourDrivingAndRestrainingForces')}/>
                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.savePageData('Page7')}
                                                     className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>

                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>


                    </div>
                </div>
            </div>
        </div>;
    }
}